import React, { createContext, useState, useEffect } from 'react';
import XLSX from 'xlsx';
import { useFormik } from 'formik';
import * as Yup from "yup";
import moment from 'moment';
import _ from 'lodash';
import { Card, Form, Jumbotron, Col, Button } from 'react-bootstrap';
import FormControls from '../../controls/formControls';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';
import { CustomerAccountService } from '../../services';
import { LinkContainer } from 'react-router-bootstrap';

const monthPrevious = (last = false) => {
    var d = new Date();
    d.setDate(0);
    if (!last) {
        d.setDate(1);
    }
    return d;
}

const CustomerMetrics = (props) => {

    return (
        <Card className="h-80">

            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Customer Metrics</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                    <LinkContainer to={'/customer/metrics/assessment/qa'}>
                        <a>Assessment QA Report</a>
                    </LinkContainer><br/><br/>
                    <LinkContainer to={'/customer/metrics/codingevents/'}>
                        <a>Coding History Report</a>
                    </LinkContainer>
            </Card.Body>
        </Card>
    )
}

export default CustomerMetrics;